module.exports = __webpack_public_path__ + "img/material.38f3d2f7.jpg";